module.exports = __webpack_public_path__ + "img/left_leaf.42d7bab5.png";